/**
 * Declaraciones de la operación en ventana independiente (Diego 2026-10-18): la declaración de importación y la declaración
 * andina del valor, de solo lectura, para el Ejecutivo de Cuenta y cualquiera que trabaje la operación. Misma mecánica que el
 * informe de inspección: ruta propia, sesión persistida; sin sesión vuelve al inicio.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-10-18
 */
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import Verdecla from "../components/Modimpxx/Nacional/Verdecla";
import { getisLoggedIn } from "../libs/redux/slices/authSlice/authSlice";

const DeclaracionesPage = () => {
  const { DOCNROXX } = useParams();
  const isLoggedIn = useSelector(getisLoggedIn);
  if (!isLoggedIn) {
    return <Navigate to="/" />;
  }
  return (
    <div style={{ minHeight: "100vh", background: "#F5F5F5" }}>
      <Verdecla DOCNROXX={DOCNROXX} onVolver={() => window.close()} />
    </div>
  );
};

export default DeclaracionesPage;
